(function () {
  function initDigiInfoProdutos(section) {
    if (!section) return;

    const form = section.querySelector('[data-digi-product-form]');
    const quantityInput = section.querySelector('[data-digi-quantity]');
    const minusButton = section.querySelector('[data-digi-qty-minus]');
    const plusButton = section.querySelector('[data-digi-qty-plus]');
    const discountOptions = section.querySelectorAll('[data-digi-discount-option]');
    const addButton = section.querySelector('[data-digi-add-button]');
    const formMessage = section.querySelector('[data-digi-form-message]');
    const cepInput = section.querySelector('[data-digi-cep]');
    const shippingButton = section.querySelector('[data-digi-shipping-button]');
    const shippingMessage = section.querySelector('[data-digi-shipping-message]');
    const upsellButtons = section.querySelectorAll('[data-upsell-add]');

    function setQuantity(value) {
      if (!quantityInput) return;

      const parsedValue = parseInt(value, 10);
      quantityInput.value = Number.isNaN(parsedValue) || parsedValue < 1 ? 1 : parsedValue;
    }

    function updateSelectedDiscount(selectedInput) {
      discountOptions.forEach((input) => {
        const option = input.closest('.digi-product__discount-option');
        if (!option) return;

        option.classList.toggle('is-selected', input === selectedInput);
      });

      setQuantity(selectedInput.value);
    }

    if (minusButton) {
      minusButton.addEventListener('click', function () {
        setQuantity(parseInt(quantityInput.value || '1', 10) - 1);
      });
    }

    if (plusButton) {
      plusButton.addEventListener('click', function () {
        setQuantity(parseInt(quantityInput.value || '1', 10) + 1);
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        setQuantity(quantityInput.value);
      });
    }

    discountOptions.forEach((input) => {
      input.addEventListener('change', function () {
        updateSelectedDiscount(input);
      });
    });

    function openCartDrawer() {
      const selectors = [
        '[data-open-cart-sidebar]',
        '[data-cart-toggle]',
        '.cart-toggle',
        '.header__icon--cart'
      ];

      for (let sel of selectors) {
        const btn = document.querySelector(sel);
        if (btn) {
          btn.click();
          return;
        }
      }

      // fallback
      document.body.classList.add('open-cart-sidebar');
    }

    if (addButton.classList.contains('is-loading')) return;

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (!addButton) return;

        const label = addButton.querySelector('.digi-product__add-label');
        const defaultText = label ? label.textContent : '';

        const formData = new FormData(form);

        // 🔥 loading instantâneo
        addButton.classList.add('is-loading');
        addButton.disabled = true;

        if (label) label.textContent = 'ADICIONANDO...';

        // 🔥 abre drawer IMEDIATO (igual vitrine)
        openCartDrawer();

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((error) => Promise.reject(error));
            }
            return response.json();
          })
          .then(() => {
            if (typeof Shopify !== 'undefined' && Shopify.getCart) {
              Shopify.getCart(function (cart) {
                if (typeof window.updateCart === 'function') {
                  window.updateCart(cart);
                }
              });
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            addButton.classList.remove('is-loading');
            addButton.disabled = false;

            if (label) label.textContent = defaultText;
          });
      });
    }

    /* =========================
      GALERIA CARROSSEL
    ========================= */

    const track = section.querySelector('[data-digi-gallery-track]');
    const dots = section.querySelectorAll('[data-digi-dot]');
    const thumbs = section.querySelectorAll('[data-digi-thumb]');
    const isDesktop = window.matchMedia('(min-width: 990px)').matches;
    const isStackedGallery =
      isDesktop && section.classList.contains('digi-product--gallery-stacked');
    let currentSlide = 0;

    if (track && !isStackedGallery) {
      const slides = track.querySelectorAll('.digi-product__gallery-slide');

      function updateUI(index) {

        dots.forEach((dot) => {
          dot.classList.remove('is-active');
        });

        thumbs.forEach((thumb) => {
          thumb.classList.remove('is-active');
        });

        if (dots[index]) {
          dots[index].classList.add('is-active');
        }

        if (thumbs[index]) {
          thumbs[index].classList.add('is-active');
        }
      }

      function goToSlide(index) {
        if (index < 0) index = 0;
        if (index > slides.length - 1) index = slides.length - 1;

        currentSlide = index;
        track.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
        updateUI(index);
      }

      // clique nas bolinhas
      dots.forEach((dot) => {
        dot.addEventListener('click', function () {
          const index = parseInt(dot.dataset.index);
          goToSlide(index);
        });
      });

      /* 🔥 ADICIONA AQUI */
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', function () {
          const index = parseInt(thumb.dataset.index);
          goToSlide(index);
        });
      });

      // swipe
      let startX = 0;

      track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      track.addEventListener('touchend', (e) => {
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;

        if (diff > 50 && currentSlide < slides.length - 1) {
          goToSlide(currentSlide + 1);
        }

        if (diff < -50 && currentSlide > 0) {
          goToSlide(currentSlide - 1);
        }
      });
    }

    upsellButtons.forEach((button) => {

      button.addEventListener('click', function () {
        if (button.disabled) return;

        if (button.classList.contains('is-loading')) return;

        const variantId = button.dataset.variantId;

        const label = button.querySelector('.digi-product__upsell-label');

        const defaultText = label ? label.textContent : '';

        button.classList.add('is-loading');
        button.disabled = true;

        if (label) {
          label.textContent = 'ADICIONANDO...';
        }

        openCartDrawer();

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((error) => Promise.reject(error));
            }

            return response.json();
          })
          .then(() => {

            if (typeof Shopify !== 'undefined' && Shopify.getCart) {

              Shopify.getCart(function (cart) {

                if (typeof window.updateCart === 'function') {
                  window.updateCart(cart);
                }

              });

            }

          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {

            button.classList.remove('is-loading');
            button.disabled = false;

            if (label) {
              label.textContent = defaultText;
            }

          });

      });

    });

  }

  function initAllDigiInfoProdutos() {
    document.querySelectorAll('.digi-product').forEach(initDigiInfoProdutos);
  }

  document.addEventListener('DOMContentLoaded', initAllDigiInfoProdutos);

  document.addEventListener('shopify:section:load', function (event) {
    initDigiInfoProdutos(event.target);
  });

  const flavorsLists = document.querySelectorAll('.digi-product__flavors-list');

  flavorsLists.forEach((list) => {

    let isDown = false;
    let startX;
    let scrollLeft;
    let moved = false;

    list.addEventListener('mousedown', (e) => {

      isDown = true;
      moved = false;

      list.classList.add('is-dragging');

      startX = e.pageX - list.offsetLeft;
      scrollLeft = list.scrollLeft;

    });

    list.addEventListener('mouseleave', () => {

      isDown = false;
      list.classList.remove('is-dragging');

    });

    list.addEventListener('mouseup', () => {

      isDown = false;

      requestAnimationFrame(() => {
        moved = false;
      });

      list.classList.remove('is-dragging');

    });

    list.addEventListener('mousemove', (e) => {

      if (!isDown) return;

      const x = e.pageX - list.offsetLeft;
      const walk = x - startX;

      // só considera drag se moveu mesmo
      if (Math.abs(walk) > 6) {
        moved = true;
      }

      if (!moved) return;

      e.preventDefault();

      list.scrollLeft = scrollLeft - (walk * 1.2);

    });

    list.querySelectorAll('a').forEach((link) => {

      link.addEventListener('click', (e) => {

        if (moved) {
          e.preventDefault();
        }

      });

    });

  });
})();